import api, { studentApi } from "./api";

const studentService = {
  list: (params) => api.get("/students", { params }).then((r) => r.data),
  get: (id) => api.get(`/students/${id}`).then((r) => r.data),
  setStatus: (id, is_active) =>
    api.patch(`/students/${id}/status`, { is_active }).then((r) => r.data),

  // Student-facing application submission (multipart/form-data) — requires student login
  apply: (formData, onUploadProgress) =>
    studentApi
      .post("/students/apply", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      })
      .then((r) => r.data),
};

export default studentService;
